module.exports = __webpack_public_path__ + "static/media/search_light.dcf98ef2.svg";